import type { RidesVehicleView } from '@actschurch/ccms-sdk';
import { PlateChip } from './PlateChip';

export function vehicleLabel(v: RidesVehicleView | null | undefined): string {
  if (!v) return '';
  return (v.label || `${v.make} ${v.model}`).trim();
}

/** "Toyota Corolla · Silver  [HTG 418 GP]" */
export function VehicleLine({ vehicle, largePlate }: { vehicle: RidesVehicleView | null | undefined; largePlate?: boolean }) {
  if (!vehicle) return null;
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
      <span>
        {vehicleLabel(vehicle)}
        {vehicle.colour ? ` · ${vehicle.colour}` : ''}
      </span>
      <PlateChip plate={vehicle.plate} large={largePlate} />
    </span>
  );
}
